import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './components/auth/AuthProvider'
import LandingApp from './App'
import ChatAppV2 from './components/chat-page-v2/App'
import { AdminDashboardPage } from './pages/admin/AdminDashboardPage'
import { AdminProtectedRoute } from './pages/admin/AdminProtectedRoute'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { VoiceAgentPage } from './pages/VoiceAgentPage'
import { CustomGPTListPage } from './pages/custom-gpt/CustomGPTListPage'
import { CustomGPTCreatePage } from './pages/custom-gpt/CustomGPTCreatePage'
import { CustomGPTEditPage } from './pages/custom-gpt/CustomGPTEditPage'
import { PlaybookChatPageV2 } from './pages/playbooks/PlaybookChatPageV2.tsx'
import { LoginPage } from './pages/LoginPage'
import ErrorBoundary from './components/ErrorBoundary'
import { ThemeProvider } from './components/ThemeProvider'
import './styles/globals.css'
import './components/chat-page-v2/styles/tokens.css'

console.log('Firebase Auth setup successful')

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <HashRouter>
        <AuthProvider>
          <ThemeProvider>
            <Routes>
              <Route path="/" element={<LandingApp />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/chat" element={
                <ProtectedRoute>
                  <ChatAppV2 />
                </ProtectedRoute>
              } />
              <Route path="/admin" element={
                <AdminProtectedRoute>
                  <AdminDashboardPage />
                </AdminProtectedRoute>
              } />
              <Route path="/admin-test" element={<AdminDashboardPage />} />
              <Route path="/voice-agent" element={
                <ProtectedRoute>
                  <VoiceAgentPage />
                </ProtectedRoute>
              } />
              <Route path="/playbooks" element={
                <ProtectedRoute>
                  <CustomGPTListPage />
                </ProtectedRoute>
              } />
              <Route path="/playbooks/new" element={
                <ProtectedRoute>
                  <CustomGPTCreatePage />
                </ProtectedRoute>
              } />
              <Route path="/playbooks/:id/edit" element={
                <ProtectedRoute>
                  <CustomGPTEditPage />
                </ProtectedRoute>
              } />
              <Route path="/playbooks/:id/chat" element={
                <ProtectedRoute>
                  <PlaybookChatPageV2 />
                </ProtectedRoute>
              } />
              {/* Backwards-compatible redirects */}
              <Route path="/custom-gpts" element={<Navigate to="/playbooks" replace />} />
              <Route path="/custom-gpts/new" element={<Navigate to="/playbooks/new" replace />} />
              <Route path="/custom-gpts/:id/edit" element={<Navigate to="/playbooks/:id/edit" replace />} />
              <Route path="/custom-gpts/:id/chat" element={<Navigate to="/playbooks/:id/chat" replace />} />
              <Route path="*" element={<LandingApp />} />
            </Routes>
          </ThemeProvider>
        </AuthProvider>
      </HashRouter>
    </ErrorBoundary>
  </StrictMode>,
)